<script setup>
import moment from "moment";
import { reactive,defineProps } from "vue";
import { useStore } from "vuex";
import BaseButton from "./BaseButton.vue";
import CardComponent from "./CardComponent.vue";

defineProps({
  value: {
    type: Number,
    default: 0,
  },
  icon: {
    type: String,
    default: null,
  },
  prefix: {
    type: String,
    default: null,
  },
  suffix: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: null,
  },
  trend: {
    type: String,
    default: null,
  },
  trendType: {
    type: String,
    default: null,
  },
});

const defaultvalues = [
  { name: "Pending", count: 5 },
  { name: "Approved", count: 25 },
  { name: "Rejected", count: 2 }
];

const store = useStore();

const formVar = reactive({
  type: "Status",
  fromDate: moment().format("YYYY-MM-DD"),
  toDate: moment().format("YYYY-MM-DD"),
  date: true,
});

function loadData(data) {
  if (data == "Staffs") {
    store.dispatch("Dashboard/assessmentCounts", {
      select: formVar.type,
      fromDate: formVar.fromDate,
      toDate: formVar.toDate,
      date: formVar.date,
    });
  } else if (data == "Users") {
    store.dispatch("Dashboard/consultationCounts", {
      select: formVar.type,
      fromDate: formVar.fromDate,
      toDate: formVar.toDate,
      date: formVar.date,
    });
  } 
}
</script>

<template>
  <card-component>
    <level-two>
      <div class="space-y-1 md:text-left w-full">
        <h3 class="text-md leading-tight font-semibold">
          {{ label }}
        </h3>
        <div>
          <div class="grid grid-cols-2 gap-2 lg:grid-cols-4">
            <select
              v-model="formVar.type"
              class="form-select appearance-none block w-full px-2 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-dark-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            >
              <option value="Method">Method</option>
              <option value="Status">Status</option>
              <option value="Type">Type</option>
              <option value="Mode">Mode</option>
            </select>
            <base-control
              v-model="formVar.fromDate"
              type="date"
              placeholder="From Date"
            />
            <base-control
              v-model="formVar.toDate"
              type="date"
              placeholder="From Date"
            />
            <base-button
              type="button"
              color="info"
              class="p-1 form-i"
              small
              label="SUBMIT"
              @click.prevent="loadData(label)"
            />
          </div>
        </div>

        <div
          class="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-5"
          v-if="label === 'Staffs'"
        >
          <label
            for="Staffs"
            v-for="(item, index) in defaultvalues"
            :key="index"
          >
            <span class="text-blue-900 font-semibold text-xl">
              {{ item.name }} : {{ item.count }}
            </span>
          </label>
        </div>

        <div
          class="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-5"
          v-if="label === 'Users'"
        >
          <label
            for="Users"
            v-for="(item, index) in defaultvalues"
            :key="index"
          >
            <span class="text-blue-900 font-semibold text-xl">
              {{ item.name }} : {{ item.count }}
            </span>
          </label>
        </div>
      </div>
    </level-two>
  </card-component>
</template>
